import gsap from 'gsap'

const closeOffPageHide = (e) => {

  const targets = gsap.utils.toArray([
    '.offpage-translate',
    '.transform-offscreen-child .curtains-canvas'
  ])

  targets.forEach(target => {
      gsap.to(targets, {x:0, duration:1, ease:"expo.out"})
  })

}
  

  export default closeOffPageHide;